import { Article } from 'schema-dts';

import { JsonLd } from '@sola/ark-skippy/atoms/jsonLd/jsonLd.js';
import { ArticleTemplate } from '@sola/ark-skippy/templates/article/article-template.js';
import { buildArticleJsonLd } from '@sola/ark-skippy/utils/schema-utils.js';
import { LOCALES_CODES } from '@sola/contentful-model/lib/types.js';
import { ArticleResponseDto } from '@sola/schema/lib/contentful.js';

import { extractArgsArticle } from '../logic';

export const RenderArticle = ({
  article,
  locale,
  path,
  experiments,
}: {
  article: ArticleResponseDto;
  locale: LOCALES_CODES;
  path: string;
  experiments?: string[];
}) => {
  const props = extractArgsArticle(article);
  if (!props) {
    return;
  }

  // TODO: add logic for different types of articles with different templates
  return (
    <>
      <JsonLd<Article>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          ...buildArticleJsonLd(props, path),
        }}
      />
      <ArticleTemplate article={props} experiments={experiments} />
    </>
  );
};
